import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { RestfullApiService } from "../config/service";
import { encryptData } from ".././utils/storage";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import { removeSpace } from "../utils";

const Wishlist = () => {
  const user = useSelector((state) => state.user.userProfile);
  // const user = JSON.parse(localStorage.getItem("userProf"));
  const navigate = useNavigate();

  const [wishlistData, setWishlistData] = useState([]);

  const handleDelete = async (EventId, EventName) => {
    if (!user) {
      console.error("User data not found");
      return;
    }

    const reqdata = {
      Org_Id: user?.Org_Id,
      Session_User_Id: user?.Participant_Id,
      Session_User_Name: `${user?.First_Name} ${user?.Last_Name}`,
      Method_Name: "Delete",
      Event_Id: EventId,
      Display_Name: EventName,
    };

    // Show confirmation dialog using SweetAlert
    const shouldDelete = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (shouldDelete.isConfirmed) {
      try {
        const result = await RestfullApiService(
          reqdata,
          "participant/wishlist_set"
        );

        if (result) {
          console.log("Delete operation successful:", result);
          // Optionally show a success message
          // const updatedWishlist = wishlistData.filter(
          //   (item) => item.Event_Id !== deletedItemId
          // );
          // setWishlistData(updatedWishlist);
          // Optionally show a success message
          Swal.fire("Deleted!", "", "success");

          // Call wishlistHandle to fetch updated wishlist after deletion
          wishlistHandle();
        }
      } catch (err) {
        console.error("API Error:", err);
        toast.error("Failed to delete wish");
      }
    }
  };

  async function wishlistHandle() {
    const reqdata = {
      Org_Id: user?.Org_Id,
      Session_User_Id: user?.Participant_Id,
      Session_User_Name: `${user?.First_Name} ${user?.Last_Name}`,
      Method_Name: "MyWishlist",
      // Session_User_Id: "M008241000011",
      // Org_Id: "FI01",
      // Session_User_Name: "omksef",
    };

    // console.log("Request Data:", reqdata);

    try {
      const result = await RestfullApiService(
        reqdata,
        "participant/Profile_get"
      );
      // console.log("API Response:", result);

      if (result) {
        setWishlistData(result?.data?.Result.Table1);

        console.log(result);
        return result;
      }
    } catch (err) {
      console.error("API Error:", err);
      toast.error(err?.response?.data?.message);
    }
  }

  const navigateToEvent = (nav, displayName) => {
    navigate(`/event-details/${removeSpace(displayName)}/${nav}`);
  };

  useEffect(() => {
    wishlistHandle();
  }, []);

  // console.log(wishlistData);
  return (
    <>
      {wishlistData?.length > 0 ? (
        <div className="row y-gap-20 justify-between items-end lg:pb-20 md:pb-10">
          <div className="col-auto pt-25 pl-45 lg:pl-20">
            <h1 className="text-20 lh-14 fw-600">
              Hi👋 {user?.First_Name} !{" "}
              <span className="text-primary">
                Your wishlist is calling! Book your event now.
              </span>
            </h1>
          </div>
          <div className="col-auto"></div>
        </div>
      ) : (
        <div className="row y-gap-20 justify-between items-end pb-20 lg:pb-20 md:pb-10">
          <div className="col-auto">
            <h1 className="text-20 text-primary lh-14 fw-600">
              Hi👋 {user?.First_Name} ! No Events on Your Radar Yet?
            </h1>
            <p className="text-13 fw-500">
              We have a ton of exciting events happening near you! Check them
              out and see if any spark your interest.
            </p>
          </div>
          <div className="col-auto"></div>
        </div>
      )}
      {wishlistData?.length > 0 && (
        <div className="py-30 px-30 lg:px-0 lg:pt-0 rounded-4 bg-white">
          <div className="row y-gap-30">
            {wishlistData?.map((list) => {
              const encryptedParam = encryptData(list?.Event_Id);
              var arraytypevent = list.Event_Category_List?.split(",");
              return (
                <div className="col-xl-12 col-lg-12 col-sm-12 relative overflow-hidden">
                  <div className="border-light rounded-16 px-15 py-15 -hover-shadow">
                    <div className="eventsCard__content">
                      <div className="row items-center">
                        <div className="col-xl-1 col-lg-2 col-sm-6">
                          {list.Start_Date.split("/").map((datePart, index) => {
                            if (index < 2) {
                              return (
                                <h2
                                  key={index}
                                  className="text-22 font-inter text-primary fw-700 text-center"
                                >
                                  {datePart.toUpperCase()}
                                </h2>
                              );
                            }
                            return null;
                          })}
                          <div className="border-right absolute wishlist-border"></div>
                        </div>

                        <div className="col-xl-4 col-lg-4 col-sm-6">
                          <h4 className="eventsCard__title font-inter text-dark-1 text-18 lh-13 fw-600 lg:mt-15">
                            <Link
                              component="button"
                              underline="none"
                              style={{
                                color: "#000",
                                textDecorationColor: "#000",
                              }}
                              onClick={() =>
                                navigateToEvent(
                                  encryptedParam,
                                  list.Display_Name
                                )
                              }
                            >
                              <span className="trim-2">
                                {list.Display_Name}
                              </span>
                            </Link>
                          </h4>
                          <div className="mt-25 lg:mt-15">
                            <span className="font-inter lh-14 text-14 fw-500 mt-5 md:d-block lg:mb-5">
                              <i className="fas fa-map-marker-alt text-primary text-15 fw-600"></i>{" "}
                              <span className="text-reading">
                                {list.City_Name}, {list.State}
                              </span>
                            </span>
                            <span className="font-inter text-reading lh-14 text-14 fw-500 mt-5 ml-10 md:ml-0 md:mt-10">
                              <i className="fas fa-running text-primary text-15 fw-600"></i>{" "}
                              <span className="text-reading">
                                {list.EventType_Name}
                              </span>
                            </span>
                            <span className="text-light-1 lh-14 text-14 fw-600 mt-5 ml-10 md:mt-10">
                              {list.Rating === 0 ? (
                                <></>
                              ) : (
                                <>
                                  <i className="fas fa-star text-green text-15 fw-600"></i>{" "}
                                  {list.Rating}
                                </>
                              )}
                            </span>
                          </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-sm-6">
                          <div className="d-flex flex-wrap items-center mt-10 lg:mt-15">
                            {/* {list.Event_Category_List.split(",").map(
                              (category, index) => (
                                <div>
                                  <div
                                    key={index}
                                    className="bg-light-2 rounded-16 text-12 fw-600 text-dark-1 py-5 px-15 lh-1 mr-5 mb-5"
                                  >
                                    {category}
                                  </div>
                                </div>
                              )
                            )} */}

                            {arraytypevent
                              ?.slice(0, 2)
                              .map((datatype, index) => (
                                <div key={`ML${index}`} className="col-auto">
                                  <div className="bg-light-2 font-inter rounded-16 text-12 fw-600 text-dark-1 py-5 px-15 lh-1 uppercase mr-5 mb-5">
                                    {datatype.toUpperCase()}
                                  </div>
                                </div>
                              ))}
                            {arraytypevent?.length > 2 && (
                              <div className="col-auto text-10 mb-1 fw-500 text-light underline">
                                <Link
                                  to={`/event-details/${removeSpace(
                                    list.Display_Name
                                  )}/${encryptedParam}`}
                                >
                                  +{arraytypevent.length - 2} MORE..
                                </Link>
                              </div>
                            )}

                            {/* <div className="bg-light-2 rounded-16 text-12 fw-500 text-dark-1 py-5 px-15 lh-1">
                              TIMED RUN
                            </div> */}
                          </div>
                          <div className="mt-20 pb-5 md:mt-10">
                            <p className="text-12 font-inter fw-500">
                              Registrations Closing,{" "}
                              <span className="text-primary font-inter">
                                {list.Registration_Date}
                              </span>
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-2 col-lg-2 col-sm-6">
                          {/* <div className="fw-600 text-20">
                            ₹{list.Amount}
                            <span className="ml-5 text-12 fw-500">Onwards</span>
                          </div> */}
                          <div>
                            <div className="fw-700 text-24 font-inter">
                              {list?.Amount !== 0 && (
                                <span className="text-14 text-light-1 mr-4 fw-400">
                                  ₹
                                </span>
                              )}
                              {list?.Amount !== 0 ? list.Amount : "Free"}{" "}
                              {list?.Amount !== 0 && (
                                <span
                                  className="ml-5 text-12 fw-500"
                                  style={{ color: "#767676" }}
                                >
                                  Onwards
                                </span>
                              )}
                            </div>
                            <div className="mt-10">
                              <Link
                                to={`/event-details/${removeSpace(
                                  list.Display_Name
                                )}/${encryptedParam}`}
                                // className="button -sm border-primary -primary-1 text-primary rounded-25 text-12 px-10 py-10"
                                className="button font-inter -sm bg-primary -pmdark-1 text-white rounded-25 text-14 px-16 py-10"
                              >
                                Register Now
                              </Link>
                            </div>
                          </div>
                          <div className="border-right absolute wishlist-border1"></div>
                        </div>

                        <div className="col-xl-1 col-lg-1 col-sm-6">
                          <div className="">
                            <Link
                              to="#"
                              onClick={() => {
                                console.log(list);
                                handleDelete(list.Event_Id, list.Display_Name);
                              }}
                              className="button -sm text-25 text-grey-1 px-10 py-10"
                            >
                              <i className="far fa-trash-alt"></i>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
            {/* <div className="col-xl-12 col-lg-12 col-sm-12">
            <div className="border-light rounded-16 px-15 py-15 -hover-shadow">
              <div className="eventsCard__content">
                <div className="row items-center">
                  <div className="col-xl-1 col-lg-2 col-sm-6 border-right">
                    <h2 className="text-22 text-primary fw-700 text-center">
                      22 Dec
                    </h2>
                  </div>
                  <div className="col-xl-4 col-lg-4 col-sm-6">
                    <h4 className="eventsCard__title text-dark-1 text-15 lh-13 fw-600">
                      <a href="#">
                        <span className="trim-2">
                          Golden Triangle Challenge: Run through India's Rich
                          Heritage
                        </span>
                      </a>
                    </h4>
                    <div className="mt-10">
                      <span className="text-light-1 lh-14 text-14 fw-500 mt-5">
                        <i className="icon-location text-primary text-15 fw-600"></i>{" "}
                        Bangalore
                      </span>
                      <span className="text-light-1 lh-14 text-14 fw-500 mt-5 ml-10">
                        <i className="fas fa-running text-primary text-15 fw-600"></i>{" "}
                        Running
                      </span>
                      <span className="text-light-1 lh-14 text-14 fw-500 mt-5 ml-10">
                        <i className="icon-star text-primary text-15 fw-600"></i>{" "}
                        4.8
                      </span>
                    </div>
                  </div>
                  <div className="col-xl-4 col-lg-4 col-sm-6">
                    <div className="d-flex items-center mt-10">
                      <div className="bg-light-2 rounded-16 text-12 fw-500 text-dark-1 py-5 px-15 lh-1 mr-5">
                        10KM RUN
                      </div>
                      <div className="bg-light-2 rounded-16 text-12 fw-500 text-dark-1 py-5 px-15 lh-1">
                        TIMED RUN
                      </div>
                    </div>
                    <div className="mt-20 pb-5">
                      <p className="text-12">
                        Registrations Closing :{" "}
                        <span className="text-primary">April 24, 2024</span>
                      </p>
                    </div>
                  </div>
                  <div className="col-xl-2 col-lg-2 col-sm-6 border-right">
                    <div className="fw-600 text-20">
                      ₹900 <span className="ml-5 text-12 fw-500">onwards</span>
                    </div>
                    <div className="mt-10">
                      <a
                        href="event-details.html"
                        className="button -sm border-primary -primary-1 text-primary rounded-25 text-12 px-10 py-10"
                      >
                        Register Now
                      </a>
                    </div>
                  </div>
                  <div className="col-xl-1 col-lg-1 col-sm-6">
                    <div className="mt-10">
                      <a
                        href="#"
                        className="button -sm text-25 text-grey-1 px-10 py-10"
                      >
                        <i className="icon-trash"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-12 col-lg-12 col-sm-12">
            <div className="border-light rounded-16 px-15 py-15 -hover-shadow">
              <div className="eventsCard__content">
                <div className="row items-center">
                  <div className="col-xl-1 col-lg-2 col-sm-6 border-right">
                    <h2 className="text-22 text-primary fw-700 text-center">
                      27 Aug
                    </h2>
                  </div>
                  <div className="col-xl-4 col-lg-4 col-sm-6">
                    <h4 className="eventsCard__title text-dark-1 text-15 lh-13 fw-600">
                      <a href="#">
                        <span className="trim-2">
                          Golden Triangle Challenge: Run through India's Rich
                          Heritage
                        </span>
                      </a>
                    </h4>
                    <div className="mt-10">
                      <span className="text-light-1 lh-14 text-14 fw-500 mt-5">
                        <i className="icon-location text-primary text-15 fw-600"></i>{" "}
                        Bangalore
                      </span>
                      <span className="text-light-1 lh-14 text-14 fw-500 mt-5 ml-10">
                        <i className="fas fa-running text-primary text-15 fw-600"></i>{" "}
                        Running
                      </span>
                      <span className="text-light-1 lh-14 text-14 fw-500 mt-5 ml-10">
                        <i className="icon-star text-primary text-15 fw-600"></i>{" "}
                        4.8
                      </span>
                    </div>
                  </div>
                  <div className="col-xl-4 col-lg-4 col-sm-6">
                    <div className="d-flex items-center mt-10">
                      <div className="bg-light-2 rounded-16 text-12 fw-500 text-dark-1 py-5 px-15 lh-1 mr-5">
                        10KM RUN
                      </div>
                      <div className="bg-light-2 rounded-16 text-12 fw-500 text-dark-1 py-5 px-15 lh-1">
                        TIMED RUN
                      </div>
                    </div>
                    <div className="mt-20 pb-5">
                      <p className="text-12">
                        Registrations Closing :{" "}
                        <span className="text-primary">April 24, 2024</span>
                      </p>
                    </div>
                  </div>
                  <div className="col-xl-2 col-lg-2 col-sm-6 border-right">
                    <div className="fw-600 text-20">
                      ₹200 <span className="ml-5 text-12 fw-500">onwards</span>
                    </div>
                    <div className="mt-10">
                      <a
                        href="event-details.html"
                        className="button -sm border-primary -primary-1 text-primary rounded-25 text-12 px-10 py-10"
                      >
                        Register Now
                      </a>
                    </div>
                  </div>
                  <div className="col-xl-1 col-lg-1 col-sm-6">
                    <div className="mt-10">
                      <a
                        href="#"
                        className="button -sm text-25 text-grey-1 px-10 py-10"
                      >
                        <i className="icon-trash"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-12 col-lg-12 col-sm-12">
            <div className="border-light rounded-16 px-15 py-15 -hover-shadow">
              <div className="eventsCard__content">
                <div className="row items-center">
                  <div className="col-xl-1 col-lg-2 col-sm-6 border-right">
                    <h2 className="text-22 text-primary fw-700 text-center">
                      22 Apr
                    </h2>
                  </div>
                  <div className="col-xl-4 col-lg-4 col-sm-6">
                    <h4 className="eventsCard__title text-dark-1 text-15 lh-13 fw-600">
                      <a href="#">
                        <span className="trim-2">
                          Golden Triangle Challenge: Run through India's Rich
                          Heritage
                        </span>
                      </a>
                    </h4>
                    <div className="mt-10">
                      <span className="text-light-1 lh-14 text-14 fw-500 mt-5">
                        <i className="icon-location text-primary text-15 fw-600"></i>{" "}
                        Bangalore
                      </span>
                      <span className="text-light-1 lh-14 text-14 fw-500 mt-5 ml-10">
                        <i className="fas fa-running text-primary text-15 fw-600"></i>{" "}
                        Running
                      </span>
                      <span className="text-light-1 lh-14 text-14 fw-500 mt-5 ml-10">
                        <i className="icon-star text-primary text-15 fw-600"></i>{" "}
                        4.8
                      </span>
                    </div>
                  </div>
                  <div className="col-xl-4 col-lg-4 col-sm-6">
                    <div className="d-flex items-center mt-10">
                      <div className="bg-light-2 rounded-16 text-12 fw-500 text-dark-1 py-5 px-15 lh-1 mr-5">
                        10KM RUN
                      </div>
                      <div className="bg-light-2 rounded-16 text-12 fw-500 text-dark-1 py-5 px-15 lh-1">
                        TIMED RUN
                      </div>
                    </div>
                    <div className="mt-20 pb-5">
                      <p className="text-12">
                        Registrations Closing :{" "}
                        <span className="text-primary">April 24, 2024</span>
                      </p>
                    </div>
                  </div>
                  <div className="col-xl-2 col-lg-2 col-sm-6 border-right">
                    <div className="fw-600 text-20">
                      ₹800 <span className="ml-5 text-12 fw-500">onwards</span>
                    </div>
                    <div className="mt-10">
                      <a
                        href="event-details.html"
                        className="button -sm border-primary -primary-1 text-primary rounded-25 text-12 px-10 py-10"
                      >
                        Register Now
                      </a>
                    </div>
                  </div>
                  <div className="col-xl-1 col-lg-1 col-sm-6">
                    <div className="mt-10">
                      <a
                        href="#"
                        className="button -sm text-25 text-grey-1 px-10 py-10"
                      >
                        <i className="icon-trash"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          </div>
        </div>
      )}
    </>
  );
};

export default Wishlist;
